import { IdhaApiException } from "../../../js/idha-api-exception";
import { utilsModule } from "../utils-module";
import Raven from 'raven-js'

let idhaApiError = null

utilsModule.factory('idhaApiError', ['dialogs', '$translate','$injector',function (dialogs, $translate,$injector) {

    return function (e: IdhaApiException | any, _module?: string, multiple?: boolean) {
        var msg = "UNKNOWN_ERROR";
        var userMsg = "UNKNOWN_ERROR";


        var dialogToShow = dialogs.error;

        if (e instanceof IdhaApiException) {
            _module = e.module;
        } else if (e.data?.error) {
            // Loopback AngularJS API
            e = e.data.error;
            _module = (e?.params?.module||_module); //Se o module vier nos parametros da requisição, utilizar ele, e nao o informado por parametro
        }else if(e.response?.data?.error){
            // Axios
            e = e.response?.data?.error
            _module = (e?.params?.module||_module); //Se o module vier nos parametros da requisição, utilizar ele, e nao o informado por parametro
        }

        switch (e.statusCode || e.status || e.xhrStatus) {
            case 400:
                if (e?.message == 'OUTDATED_APP') {
                    return handleOutdatedApp(e);
                }
            case 403:
            case 500:
            case 422:
                if (_module != null) {
                    msg = e.errorCode ? `ERROR_${_module.toUpperCase()}_${e.errorCode}` : `ERROR_HTTP_${e.statusCode || e.status}`;
                    dialogToShow = dialogs.alert;
                } else {
                    dialogToShow = dialogs.error
                }

                userMsg = msg;

                break;
            case 401:
            case 404:
                msg = e.description || e;
                userMsg = e.errorCode ? `ERROR_HTTP_${e.statusCode || e.status}` : `ERROR_HTTP_${e.statusCode || e.status}`;
                dialogToShow = dialogs.error;
                break;

        }

        msg = $translate.instant(msg, e.params);
        userMsg = $translate.instant(userMsg, e.params);

        console.error(e)

        Raven.captureException(e)

        return dialogToShow(userMsg, multiple);
    }


    function handleOutdatedApp(e) {
        if (typeof (<any>window).cordova !== "undefined") {
            //APP ANDROID
            var msg = 'ERROR_OUTDATED_APP_MESSAGE_ANDROID';
            var dialog = dialogs.confirm;
            var userMsg = $translate.instant('ERROR_OUTDATED_APP_MESSAGE_ANDROID', e.params);
            var dlgNo = $translate.instant('CANCEL');
            var dlgYes = $translate.instant('UPDATE_NOW');

            return dialog($translate.instant(userMsg, e.params), dlgYes, dlgNo)
                .then(() => {
                    (<any>window).open('market://details?id=br.com.idha.idhaapp', "_system");
                })
        } else {
            //VERSÃO WEB
            var msg = 'ERROR_OUTDATED_APP_MESSAGE_WEB';
            var dialog = dialogs.alert;
            var userMsg = $translate.instant('ERROR_OUTDATED_APP_MESSAGE_WEB', e.params);

            return dialog($translate.instant(userMsg, e.params));
        }
    }
}])

utilsModule.run(['$injector', function($injector){
    idhaApiError = $injector.get('idhaApiError')
}])

export {idhaApiError}
